import { useLazyQuery } from "@apollo/client";
import { useState, useEffect } from "react";
import { DOES_CONTACT_EXIST } from "../graphql/contact";
import { useTranslation } from "react-i18next";
import type { ExistingContact } from "../components/admin/contacts/ExistingContactPopover";

const useCheckIfContactAlreadyExists = (
  nameToMatch: string | null,
  fieldToMatch: "website" | "email",
  onCompleted: () => void,
  contactId: string | null,
) => {
  const { t } = useTranslation();
  const [existingContact, setExistingContact] =
    useState<ExistingContact | null>(null);
  const [error, setError] = useState("");

  const [
    fetchContactExistence,
    { loading: loadingCheckIfContactAlreadyExists, data },
  ] = useLazyQuery(DOES_CONTACT_EXIST, {
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (nameToMatch && fieldToMatch) {
      fetchContactExistence({
        variables: {
          input: { [fieldToMatch]: nameToMatch.toLowerCase() },
        },
      });
    }
  }, [nameToMatch, fieldToMatch, fetchContactExistence]);

  useEffect(() => {
    if (data) {
      const contact: ExistingContact | null =
        data.doesContactExist.length > 0 ? data.doesContactExist[0] : null;
      setExistingContact(contact);

      const isSameContactId = contact && contact.id === contactId;
      setError(
        contact && !isSameContactId
          ? t("A contact with this field already exists. Click here to view it")
          : "",
      );
      onCompleted();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, contactId]);

  return { existingContact, error, loadingCheckIfContactAlreadyExists };
};

export default useCheckIfContactAlreadyExists;
